import React from 'react'
import { useNavigate } from 'react-router-dom'
import { match } from 'ts-pattern'

import { Footer } from '@frame/ui-components/footer'
import { VerificationMethodCard } from '@frame/ui-components/verification-method-card'
import { WidgetHeaderWithNavigation } from '@frame/ui-components/widget-header'
import { Body } from '@frame/ui-primitives/body'
import { Button } from '@frame/ui-primitives/button'
import { H2 } from '@frame/ui-primitives/h2'

import { TrueworkJsStrategy } from '@frame/lib/api/tasks/types'
import { useAutoNavigate } from '@frame/lib/hooks/useAutoNavigate'
import { useDirectTask } from '@frame/lib/hooks/useDirectTask'
import { useHeaderTitle } from '@frame/lib/hooks/useHeaderTitle'
import { useShowExitPrompt } from '@frame/lib/hooks/useShowExitPrompt'
import { useStrategies } from '@frame/lib/hooks/useStrategies'
import { routes } from '@frame/routes'
import { DataAttribute } from '@frame/types'

export function AlternativeMethods() {
  const navigate = useNavigate()
  const { bilEnabledStrategesNoDocuments } = useStrategies()

  const { mutateAndNavigate } = useAutoNavigate()
  const title = useHeaderTitle()
  const showExitPrompt = useShowExitPrompt()
  const task = useDirectTask()

  function handleClick(strategy: TrueworkJsStrategy) {
    return match(strategy)
      .with(TrueworkJsStrategy.BANK, handleClickBank)
      .with(TrueworkJsStrategy.CREDENTIALS, handleClickCredentials)
      .otherwise(() => null)
  }

  function handleClickBank() {
    navigate(`${routes.bankStatedInformation}/${task?.id}`)
  }

  function handleClickCredentials() {
    if (task?.id) {
      const params = new URLSearchParams()
      params.set('q', task?.employer_name || '')
      navigate(`${routes.companySearch}/${task?.id}?${params.toString()}`)
    } else {
      navigate(routes.companySearch)
    }
  }

  function handleStartOver() {
    mutateAndNavigate()
  }

  return (
    <>
      <WidgetHeaderWithNavigation title={title} showExitPrompt={showExitPrompt} />
      <Body data-cy={DataAttribute.DOCUMENTS_SCREEN_ALTERNATIVE_METHODS} className="p-5" paddingTopOverride={0}>
        <H2 className="text-left">Alternative methods</H2>
        <div className="mt-4 flex flex-col gap-4">
          {bilEnabledStrategesNoDocuments.map((strategy, idx) => {
            const onClick = () => handleClick(strategy)

            if (!onClick) return null

            return (
              <VerificationMethodCard
                key={strategy}
                strategy={strategy}
                intent={idx === 0 ? 'primary' : 'secondary'}
                onClick={onClick}
              />
            )
          })}
        </div>
      </Body>
      <Footer
        buttons={{
          primary: (
            <Button disabled={false} intent="tertiary" onClick={handleStartOver}>
              Start over
            </Button>
          ),
        }}
      />
    </>
  )
}
